import { render, staticRenderFns } from "./header-menus.vue?vue&type=template&id=78a78cdc&"
import script from "./header-menus.vue?vue&type=script&lang=js&"
export * from "./header-menus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CText: require('@chakra-ui/vue').CText, CMenuButton: require('@chakra-ui/vue').CMenuButton, CFlex: require('@chakra-ui/vue').CFlex, CMenuList: require('@chakra-ui/vue').CMenuList, CMenu: require('@chakra-ui/vue').CMenu, CListItem: require('@chakra-ui/vue').CListItem})
